import React from 'react'

import {t} from '@lib/helpers'
import {
  CAPABILITY_ICON_SIZE,
  capabilityIcons,
  html,
  PARTNER_AWS_SOLUTION_SECTION_ID,
  SOLUTION_CARD_HEIGHT,
  SOLUTION_CARD_WIDTH,
  solutionCardImages,
  zipWithImage,
} from './constant'

export default function Capability() {
  const cards = zipWithImage(
    t('pages.partnerAws.solution.cards'),
    solutionCardImages
  )
  const capabilities = zipWithImage(
    t('pages.partnerAws.capability.items'),
    capabilityIcons
  )

  return (
    <React.Fragment>
      <section
        className='PartnerAws__solution'
        id={PARTNER_AWS_SOLUTION_SECTION_ID}
      >
        <div className='PartnerAws__inner'>
          <div className='PartnerAws__solution__header'>
            <div>
              <p className='PartnerAws__caption PartnerAws__gradient-text'>
                {t('pages.partnerAws.solution.caption')}
              </p>
              <h2 className='PartnerAws__section-title'>
                {t('pages.partnerAws.solution.titleLine1')}
                <br />
                {t('pages.partnerAws.solution.titleLine2')}
              </h2>
            </div>
            <p className='PartnerAws__solution__description'>
              {t('pages.partnerAws.solution.description')}
            </p>
          </div>

          {/*
          Each card is a flattened Figma export rather than markup, so the
          title, description and tags live inside the SVG. They stay in the
          locale (and in the alt text) so the copy has one source of truth.
        */}
          <div className='PartnerAws__solution__cards'>
            {cards.map((card, index) => (
              <img
                className='PartnerAws__solution__card'
                key={index}
                src={card.image}
                alt={`${card.title} - ${card.description}`}
                width={SOLUTION_CARD_WIDTH}
                height={SOLUTION_CARD_HEIGHT}
              />
            ))}
          </div>
        </div>
      </section>

      <section className='PartnerAws__capability'>
        <div className='PartnerAws__inner'>
          <div className='PartnerAws__capability__header'>
            <p className='PartnerAws__caption PartnerAws__gradient-text'>
              {t('pages.partnerAws.capability.caption')}
            </p>
            <h2
              className='PartnerAws__section-title PartnerAws__section-title--light'
              {...html(t('pages.partnerAws.capability.title'))}
            />
          </div>

          <div className='PartnerAws__capability__grid'>
            {capabilities.map((item, index) => (
              <div className='PartnerAws__capability__item' key={index}>
                <div className='PartnerAws__capability__item__badge'>
                  {!!item.image && (
                    <img
                      src={item.image}
                      alt=''
                      width={CAPABILITY_ICON_SIZE}
                      height={CAPABILITY_ICON_SIZE}
                    />
                  )}
                </div>
                <div className='PartnerAws__capability__item__text'>
                  <h3 className='PartnerAws__capability__item__title'>
                    {item.title}
                  </h3>
                  <p
                    className='PartnerAws__capability__item__description'
                    {...html(item.description)}
                  />
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </React.Fragment>
  )
}
